import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download, Clock, Battery } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FinalCTA() {
  const handleBuyClick = () => {
    // Fire Meta Pixel AddToCart event
    trackAddToCart(6.39, 'USD');
    // Redirect to Shopify cart
    window.open('https://www.gemmamama.com/cart/45148983787659:1', '_blank');
  };
  return <Section id="comprar" background="beige" className="text-center pb-32" data-id="element-12">
      <div className="bg-[#FAF7F2] rounded-3xl p-8 md:p-16 shadow-xl max-w-4xl mx-auto border border-white/50" data-id="element-13">
        <h2 className="text-4xl md:text-5xl font-serif text-[#4A4238] mb-6" data-id="element-14">
          Start with Day 0.
        </h2>
        <p className="text-xl text-[#8C7E6E] mb-10 max-w-2xl mx-auto" data-id="element-15">
          Your only job today is to make tomorrow easier.
        </p>

        <div className="flex flex-col items-center gap-6 mb-12" data-id="element-16">
          <div className="flex flex-col items-center gap-2" data-id="element-17">
            <p className="text-sm text-[#8C7E6E] uppercase tracking-wide" data-id="element-18">
              Special Discount Offer
            </p>
            <div className="flex items-center gap-3" data-id="element-19">
              <span className="text-2xl text-[#8C7E6E] line-through" data-id="element-20">
                $12.99
              </span>
              <span className="text-5xl font-serif font-bold text-[#4A4238]" data-id="element-21">
                $6.39
              </span>
            </div>
            <span className="inline-block px-3 py-1 bg-[#7BA99E]/20 text-[#7BA99E] text-sm font-medium rounded-full" data-id="element-22">
              Save 50% Today
            </span>
          </div>
          <Button size="lg" className="w-full md:w-auto text-xl px-12 py-5 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all" onClick={handleBuyClick} data-id="element-23">
            Get The Reset Now
          </Button>
          <p className="text-sm text-[#8C7E6E] flex items-center gap-2" data-id="element-24">
            <Download size={14} data-id="element-25" /> Instant PDF Download
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 text-sm text-[#8C7E6E] border-t border-[#E8E0D5] pt-8" data-id="element-26">
          <div className="flex flex-col items-center gap-2" data-id="element-27">
            <Clock className="text-[#7BA99E]" data-id="element-28" />
            <p data-id="element-29">Read it at 2:14 a.m.</p>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-30">
            <Battery className="text-[#7BA99E]" data-id="element-31" />
            <p data-id="element-32">Run it one-handed.</p>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-33">
            <div className="w-6 h-6 rounded-full border-2 border-[#7BA99E] flex items-center justify-center font-serif font-bold text-[#7BA99E]" data-id="element-34">
              i
            </div>
            <p data-id="element-35">No new personality required.</p>
          </div>
        </div>
      </div>
    </Section>;
}